import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";

const Health = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>[열달후에] 건강정보 수집·이용 동의</PolicyTitle>

      <PolicyText>
        회원가입 시 선택항목 수집 · 이용에 대한 동의를 거부하실 수 있습니다.
        다만 선택항목 수집 · 이용에 대하여 동의하지 않으실 경우, 아래 다이어리
        서비스 이용 시 서비스 이용이 제한됩니다.
      </PolicyText>

      <PolicySectionTitle>1. 수집 목적</PolicySectionTitle>
      <PolicyHyphenList>
        <li>각 다이어리 모드별 맞춤형 서비스 제공</li>
        <li>기존 서비스의 개선 및 신규 서비스 개발</li>
        <li>서비스 이용에 대한 분석 및 통계</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. 수집항목</PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>[임신준비 다이어리 이용 시]</strong>
          <br />
          생리기간, 생리주기, 마지막 생리일, 생리시작일, 종료일, 배란일, 사용자
          기록 항목 (기록일, 통증, 출혈, 사랑일, 약복용, 예방접종, 병원진료,
          기초체온 등), 배란테스트 사진 및 결과, 임신테스트 사진 및 결과
        </li>
        <li>
          <strong>[임신준비 다이어리_난임모드 이용 시]</strong>
          <br />
          시술 방법, 시술 차수, 난임 시술 시작 및 종료일, 약물/주사 기록, 시술
          내용
        </li>
        <li>
          <strong>[임신 다이어리 이용 시]</strong>
          <br />
          출산예정일, 임신 주수 및 일수, 사용자 기록 항목(기록일, 병원진료,
          예방접종, 체중기록, 사랑일 등), 태아초음파사진,
          태아항목별수치(EFW/AC/FL/BPD/HC/CRL), 임신전 키, 체중
        </li>
        <li>
          <strong>[육아 다이어리 이용 시]</strong>
          <br />
          자녀의 생년월일, 출생 시 체중, 사용자 기록 항목(자녀의 체중, 키,
          머리둘레 등), 월령별 발달체크 항목별 기록 및 점수, 이른둥이 여부,
          임신전 체중/키, 출산 직전 주차 체중, 기록 체중, 체온 기록, 복약 기록
        </li>
      </PolicyList>

      <PolicySectionTitle>3. 보유기간</PolicySectionTitle>
      <PolicyText>
        회원이 저장 데이터를 삭제하거나 서비스 탈퇴 시 즉시 파기 (단,
        개인정보처리방침 제 10조 가명정보처리에 명시된 데이터는 회원 탈퇴 시
        식별 불가하도록 가명처리 후 보유)
      </PolicyText>
    </PolicyContainer>
  );
};

export default Health;
